<template>
  <div class="">
    <div class="card h-100">
      <div class="card-header">
        <div class="row">
          <div class="col-md-6 d-flex align-items-center">
            <h5 class="d-inline-block m-0">{{ $t('Linked Customers') }}</h5>
          </div>
          <div class="col-md-6 text-right">
            <b-button class="p-0" variant="link"
                      v-permission="changePermission"
                      @click="addOrEditLink({})">
              <font-awesome-icon :icon="'plus'" style="font-size: .9em"></font-awesome-icon>
              {{ $t('Add New') }}
            </b-button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <spinner :with-text="false" :show="loader" :height="5"/>
        <template v-if="!loader">

          <div class="row" v-if="customerLinks && customerLinks.length > 0">
            <div class="col-md-12">
              <table class="w-100 table table-sm mb-0 table-responsive">
                <tr>
                  <th class="border-top-0" style="min-width: 150px;width: 33%">{{ $t('Name') }}</th>
                  <th class="border-top-0" style="min-width: 100px;width: 33%">{{ $t('Type') }}</th>
                  <th class="border-top-0" style="min-width: 100px;width: 33%">{{ $t('Email') }}</th>
                  <th class="border-top-0" style="min-width: 100px;width: 33%">{{ $t('Phone') }}</th>
                  <th class="border-top-0" style="min-width: 100px"></th>
                </tr>
                <tr v-for="link in customerLinks" :key="`link-row-${link.uuid}`">
                  <td>
                    <template v-if="link.to_customer_uuid">
                      <template v-if="$hasPermission('view_customer')">
                        <router-link :to="{ name: 'customers.view', params: { id: link.to_customer_uuid }}">
                          {{ link.to_customer.display_name }}
                        </router-link>
                      </template>
                      <template v-else>
                        {{ link.to_customer.display_name }}
                      </template>
                    </template>
                    <template v-else>
                      {{ link.last_name }}, {{ link.first_name }}
                    </template>
                  </td>
                  <td>{{ link.description }}</td>
                  <td>{{ link.email }}</td>
                  <td>{{ link.phone }}</td>
                  <td>
                    <b-button v-permission="changePermission" variant="primary" size="sm"
                              @click="addOrEditLink(link)">
                      <font-awesome-icon :icon="'pen'"></font-awesome-icon>
                    </b-button>
                    <b-button  v-permission="deletePermission" variant="danger" size="sm"
                              @click="onLinkRemoveClick(link)" class="ml-2">
                      <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                    </b-button>
                  </td>
                </tr>
              </table>

            </div>
          </div>

          <no-data-available v-if="!customerLinks || customerLinks.length === 0" :height="5"/>
        </template>
      </div>
    </div>
    <customer-link-modal/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import NoDataAvailable from "../../../../../core/components/common/NoDataAvailable";
  import CustomerLinkModal from "./CustomerLinkModal";
  import Spinner from "../../../../../core/components/common/Spinner";
  import {SOURCE_CUSTOMER_DASHBOARD} from "@/modules/constants";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CustomerLinks",
    props: {
      changePermission: {
        type: String,
        default: null
      },
      deletePermission: {
        type: String,
        default: null
      },
    },
    components: {Spinner, CustomerLinkModal, NoDataAvailable},
    methods: {
      ...mapActions(['showCustomerLinkModal', 'removeCustomerLink']),
      addOrEditLink(link) {
        this.showCustomerLinkModal({object: link, source: SOURCE_CUSTOMER_DASHBOARD});
      },
      async onLinkRemoveClick(link) {
        this.$confirm(
            this.$i18n.t('Are you sure you want to delete this linked customer?'),
            this.$i18n.t('Customer link has been successfully deleted'),
            this.removeCustomerLink,
            {source: SOURCE_CUSTOMER_DASHBOARD, uuid: link.uuid}
        );
      },
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
        loader: state => state.dashboardData.customerLinksLoader,
        customerLinks: state => state.dashboardData.customerLinks,
      })
    },
  }
</script>

<style lang="scss" scoped>
  @import "./../../../scss/variables";
</style>
